import React from 'react'

export const ProgressBarU = () => (
  <svg
    className="player_progress_bar"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1018 648.32"
  >
    <defs>
      <linearGradient
        id="u_progress_bar_lg"
        x1="60"
        y1="0"
        x2="100"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#4f526f" />
      </linearGradient>
      <linearGradient
        id="u_left_cover_lg"
        x1="299"
        y1="0"
        x2="300"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="transparent" />
      </linearGradient>
      <linearGradient
        id="u_right_cover_lg"
        x1="750"
        y1="0"
        x2="1000"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="transparent" />
        <stop offset="0" stopColor="#4f526f" />
      </linearGradient>
    </defs>
    <path
      id="u_progress_bar"
      d="M1023.94,200.23c0-4.67.13-22.86,0-27.5,0,0-6.55,0-14.05,0H943.73c-8.06,0-15,0-15,0,14.36,104.06-6.31,244.86-41.78,305.89C815.62,601.36,672.63,686.67,522,687c-181.07-.44-317-111.62-377.65-276C105.87,306.6,105.14,141.4,124.44,58l-21.52,0H9.6C-3.57,186.14,19.54,325.73,76.14,441.46,146.81,585.94,293.3,681.55,457,702.17l2.38.3c2,.24,3.93.46,5.9.68q23.5,2.64,47.62,3.06c1.77,0,3.53,0,5.3.07,1.11,0,2.21,0,3.31,0H523q10.76,0,19.52-.49C810.3,694.57,1023.94,518.91,1023.94,200.23Z"
      transform="translate(-6 -58)"
      stroke="#4f526f"
    />
    <path
      id="u_left_cover"
      d="M1023.94,200.23c0-4.67.13-22.86,0-27.5,0,0-6.55,0-14.05,0H943.73c-8.06,0-15,0-15,0,14.36,104.06-6.31,244.86-41.78,305.89C815.62,601.36,672.63,686.67,522,687c-181.07-.44-317-111.62-377.65-276C105.87,306.6,105.14,141.4,124.44,58l-21.52,0H9.6C-3.57,186.14,19.54,325.73,76.14,441.46,146.81,585.94,293.3,681.55,457,702.17l2.38.3c2,.24,3.93.46,5.9.68q23.5,2.64,47.62,3.06c1.77,0,3.53,0,5.3.07,1.11,0,2.21,0,3.31,0H523q10.76,0,19.52-.49C810.3,694.57,1023.94,518.91,1023.94,200.23Z"
      transform="translate(-6 -58)"
      stroke="#4f526f"
    />
    <path
      id="u_right_cover"
      d="M1023.94,200.23c0-4.67.13-22.86,0-27.5,0,0-6.55,0-14.05,0H943.73c-8.06,0-15,0-15,0,14.36,104.06-6.31,244.86-41.78,305.89C815.62,601.36,672.63,686.67,522,687c-181.07-.44-317-111.62-377.65-276C105.87,306.6,105.14,141.4,124.44,58l-21.52,0H9.6C-3.57,186.14,19.54,325.73,76.14,441.46,146.81,585.94,293.3,681.55,457,702.17l2.38.3c2,.24,3.93.46,5.9.68q23.5,2.64,47.62,3.06c1.77,0,3.53,0,5.3.07,1.11,0,2.21,0,3.31,0H523q10.76,0,19.52-.49C810.3,694.57,1023.94,518.91,1023.94,200.23Z"
      transform="translate(-6 -58)"
      stroke="#4f526f"
    />
  </svg>
)

export const ProgressBarJ = () => (
  <svg
    className="player_progress_bar"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1018 757"
    style={{ enableBackground: 'new 0 0 1018 757' }}
    xmlSpace="preserve"
  >
    <defs>
      <linearGradient
        id="j_progress_bar_lg"
        gradientUnits="userSpaceOnUse"
        x1="-1"
        y1="635"
        x2="0"
        y2="636"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#4f526f" />
      </linearGradient>
    </defs>
    <path
      id="j_progress_bar"
      d="M1017.8,13.7c0,0-2.2,0-12.7,0H909c-11.3,0-21.7,0-21.7,0c17,130.4-2,342.9-74.3,448.8
	c-107.8,158-285.8,265.7-490.6,266.1C202,728.4,90.1,692.1,0.4,627.3c87.8,99.6,262.9,127.6,350.7,127.6
	c205.1,0,390.4-84.3,513.4-234.1C966.5,396.6,1021.5,260.9,1017.8,13.7z"
    />
  </svg>
)

export const ProgressBarL = () => (
  <svg
    className="player_progress_bar"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1018 757"
    style={{ enableBackground: 'new 0 0 1018 757' }}
    xmlSpace="preserve"
  >
    <defs>
      <linearGradient
        id="l_progress_bar_lg"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="10120"
        y2="0"
      >
        <stop offset="0" stopColor="#FFFFFF" />
        <stop offset="1" stopColor="#4f526f" />
      </linearGradient>
    </defs>
    <path
      id="l_progress_bar"
      d="M883.5,659.7c-73.8,47-163,72.5-257.8,72.5c-220,0-407.3-143.9-472.9-338.8c-38.4-114-35.2-315.6-12.4-395.6
	H2.8c-9.4,186.3,6.1,299.4,89.8,458.3c100,189.6,301.7,298.7,533,298.7c91.9,0,203.9-28.7,267.9-74.7
	c51.8-37.3,104.9-82.8,124.5-157.7C983.8,581.1,932,628.9,883.5,659.7z"
    />
  </svg>
)
